<template>
  <div>
    <top-bar/>
    <div class="content" style="padding: 72px 0">
      <div class="container-fluid">
        <menu-option :menus="menus" :selected="menu" @changeMenu="(m) => { this.menu = m }"/>
        <div class="mt-5" v-if="load">
          <loading/>
        </div>
        <div v-else-if="menu === 1">
          <div class="text-right mb-3">
            <button class="btn btn-primary px-4" @click="newAgent"><i class="fa fa-plus mr-1"></i> Novo</button>
          </div>
          <div class="card shadow-sm">
            <div class="card-body">
              <table class="table mb-0">
                <thead>
                <tr class="small">
                  <th>Nome</th>
                  <th>Tipo</th>
                  <th class="text-center" style="width: 100px">Alertas</th>
                  <th class="text-center">Status</th>
                  <th></th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="a in agents" v-show="!a.master || operator.master">
                  <td class="align-middle pointer" @click="editAgent(a)">{{ a.name }}</td>
                  <td class="align-middle pointer" @click="editAgent(a)">{{ a.type === 1 ? 'Administrador' : 'Atendente' }}</td>
                  <td class="align-middle text-center text-nowrap">
                    <button class="btn" @click="toggleAlerts(a)">
                      <img src="../assets/icons/switch-on.svg" class="switch" v-if="a.alerts === 1">
                      <img src="../assets/icons/switch-off.svg" class="switch" v-else>
                    </button>
                  </td>
                  <td class="align-middle text-center text-nowrap">
                    <button class="btn btn-sm mr-1" :class="a.fg_ativo === 1 ? 'btn-primary' : 'btn-secondary'" @click="toggleAgent(a, 1)">Ativado</button>
                    <button class="btn btn-sm" :class="a.fg_ativo !== 1 ? 'btn-primary' : 'btn-secondary'" @click="toggleAgent(a, 2)">Desativado</button>
                  </td>
                  <td class="text-right">
                    <button class="btn btn-primary btn-sm mr-2" @click="editAgent(a)" style="width: 32px"><i class="fa fa-pencil-alt small"></i></button>
                    <button class="btn btn-danger btn-sm mr-2" @click="removeAgent(a)" style="width: 32px" v-if="a.id !== operator.id"><i class="fa fa-trash small"></i></button>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div v-else-if="menu === 2">
          <div class="text-right mb-3">
            <button class="btn btn-primary px-4" @click="newDepartament"><i class="fa fa-plus mr-1"></i> Novo</button>
          </div>
          <div class="card shadow-sm" v-show="departaments.length">
            <div class="card-body">
              <table class="table mb-0">
                <thead>
                <tr class="small">
                  <th style="width: 290px">Nome</th>
                  <th></th>
                  <th style="width: 150px"></th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(a, index) in departaments">
                  <td class="align-middle">
                    <span class="pointer" v-if="a.id && editDep !== a.id" @click="editDepartament(a.id)">{{a.name}}</span>
                    <input :id="'dept' + index" class="form-control" v-model="a.name" placeholder="Nome Departamento" v-else/>
                  </td>
                  <td class="align-middle">
                    <select class="form-control ml-auto" v-model="a.type_trigger" style="width: 200px" :disabled="a.id && editDep !== a.id">
                      <option :value="1">Enviar para todos</option>
                      <option :value="2">Fila de Envio</option>
                    </select>
                  </td>
                  <td class="align-middle text-right">
                    <div v-if="a.id && editDep !== a.id">
                      <button class="btn btn-primary btn-sm mr-2" @click="editDepartament(a.id)" style="width: 32px">
                        <i class="fa fa-pencil-alt"></i>
                      </button>
                      <button class="btn btn-danger btn-sm" @click="removeDepartament(a)" style="width: 32px"><i class="fa fa-trash"></i></button>
                    </div>
                    <div v-else>
                      <button class="btn btn-secondary btn-sm mr-2" @click="getDepartaments()" style="width: 32px;"><i class="fa fa-times"></i></button>
                      <button class="btn btn-primary btn-sm" @click="saveDepartament(a)" style="width: 32px"><i class="fa fa-check"></i></button>
                    </div>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>

    <modal @salvar="saveAgent">
      <loading v-if="load"/>
      <div v-else-if="agent">
        <h5>{{ agent.name || 'Agente' }}</h5>
        <hr>
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label class="mb-0 small">Nome</label>
              <input type="text" class="form-control" placeholder="Nome do agente" v-model="agent.name" required>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label class="mb-0 small">Telefone ({{agent.phone.length}} de 13)</label>
              <input type="text" placeholder="5516#########" class="form-control" autocomplete="off" minlength="12" v-model="agent.phone" required>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label class="mb-0 small">Usuário</label>
              <input type="text" class="form-control" placeholder="Username" autocomplete="off" v-model="agent.username" required>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label class="mb-0 small">Permissão</label>
              <select class="form-control" v-model="agent.type">
                <option :value="1">Administrador</option>
                <option :value="2">Gerente</option>
                <option :value="3">Atendente</option>
              </select>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label class="mb-0 small">Senha</label>
              <input type="password" autocomplete="new-password" :placeholder="agent.id ? 'Deixe em branco para manter a senha' : 'Senha de acesso'" class="form-control" v-model="agent.password" :required="!agent.id">
            </div>
          </div>
        </div>
        <div>
          <hr>
          <h6 class="mb-3">Departamentos</h6>
          <div class="row">
            <div class="col-md-6 mb-1" v-for="d in departaments">
              <label><input type="checkbox" class="mr-2" :value="d.id" v-model="agent.departaments">{{ d.name }}</label>
            </div>
          </div>
        </div>
      </div>
    </modal>

  </div>
</template>

<script>
import TopBar from "@/components/TopBar";
import Modal from "@/components/Modal";
import MenuOption from "@/components/MenuOption";
import Loading from "@/components/loading";

export default {
  name: "Config",
  components: {Loading, MenuOption, Modal, TopBar},
  data() {
    return {
      menu: 1,
      menus: [
        { nome: 'Agentes', active: true },
        { nome: 'Departamentos', active: true },
      ],
      load: false,
      agents: [],
      departaments: [],
      agent: null,
      editDep: null
    }
  },

  methods: {
    getAgents() {
      this.load = true;
      this.$http.get('agents')
        .then(response => {
          this.load = false;
          this.agents = response.data || [];

        }, res => {
          this.load = false;
          console.log(res);
        });
    },

    saveAgent(callback, nLoad) {
      if (!nLoad) {
        this.load = true;
      }

      this.$http.post('agents', this.agent)
        .then(response => {
          this.load = false;
          const data = response.data;

          if (data.success) {

            if (!nLoad) {
              this.getAgents();
            }

            if (callback) {
              callback(true);
            }

          } else {
            this.$swal(data.msg || 'Houve um erro ao salvar este agente!');
          }

        }, res => {
          this.load = false;
          console.log(res);
        });
    },

    newAgent() {
      this.$emit('openModal');
      this.agent = {
        name: '',
        username: '',
        password: '',
        type: 2,
        phone: '',
        departaments: []
      };
    },

    editAgent(a) {
      this.$emit('openModal');
      this.agent = {
        id: a.id,
        name: a.name,
        username: a.username,
        password: '',
        type: a.type,
        phone: a.phone,
        fg_ativo: a.fg_ativo,
        departaments: a.departaments
      };
    },

    toggleAgent(a, fg_ativo) {
      this.agent = a;
      this.agent.fg_ativo = fg_ativo;
      this.saveAgent(null,true);
    },

    toggleAlerts(a) {
      this.agent = a;
      this.agent.alerts = a.alerts === 1 ? 0 : 1;
      this.saveAgent(null, true);
    },

    removeAgent(a) {
      this.$swal({
        text: "Deseja realmente remover este agente?",
        buttons: ["Cancelar", "Sim"],
        dangerMode: true
      }).then(r => {
        if (r) {
          this.agent = a;
          this.agent.delete = true;
          this.saveAgent();
        }
      });
    },

    getDepartaments() {
      this.editDep = null;

      this.$http.get('departaments')
        .then(response => {
          this.departaments = response.data || [];

        }, res => {
          this.load = false;
          console.log(res);
        });
    },

    newDepartament() {
      this.departaments.push({
        name: '',
        type_trigger: 1,
      })
    },

    saveDepartament(departament) {
      this.load = true;
      this.$http.post('departaments', departament)
        .then(response => {
          this.load = false;
          this.editDep = null;
          this.getDepartaments();

        }, res => {
          this.load = false;
          console.log(res);
        });
    },

    editDepartament(dep) {
      this.editDep = dep;
    },

    removeDepartament(departament) {
      this.$swal({
        text: "Deseja realmente remover este departamento?",
        buttons: ["Cancelar", "Sim"],
        dangerMode: true
      }).then(r => {
        if (r) {
          departament.fg_ativo = 0;
          this.saveDepartament(departament);
        }
      })
    },
  },

  mounted() {
    this.getDepartaments();
    this.getAgents();
  },

  computed: {
    operator() {
      return this.$store.state.dataUser;
    }
  }
}
</script>

<style scoped>
</style>
